import React from 'react';
import { withRouter } from 'next/router';
import BasePage from '@/components/BasePage';
import Error from '@/components/shared/Error';
import {
	Mumps,
	Haemophilus,
	HPV,
	Flu,
	WhoopplingCough,
	Measels,
	Polio,
	Rotavirus,
	Rubella,
	ChickenPox,
	HepatitisA,
	HepatitisB,
	Diphtheria,
	TBE,
	YellowFever,
	JapaneseBrainInflammation,
	Cholera,
	Malaria,
	MeningococcalDiseases,
	PneumococcalDiseases,
	Rabies,
	Tetanus,
	Tuberculosis,
	Typhoid
} from '@/pages/vaccines';
import Booking from '@/components/Booking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BaseLayout from '@/components/layouts/BaseLayout';
import Travels from '@/pages/travels';
import { Row, Col, Container } from 'reactstrap';
import MapGL, { Marker } from 'react-map-gl';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';
const MAPBOX_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_API_KEY;

import Pin from '../../destinations/pin';

const CountryLayout = ({ t, data }) => {
	if (data) {
		const lat = Number(data.map_lat);
		const long = Number(data.map_long);

		const viewport = {
			latitude: lat,
			longitude: long,
			zoom: 3,
			bearing: 0,
			pitch: 0
		};

		return (
			//React.Fragment is used instead of <div> or <> to hide it from source
			<React.Fragment>
				<BaseLayout
					className="cover"
					title={t(data.country)}
					description={`${t('countries.info_text1')}${t(data.country)}${t('countries.info_text2')}`}
					keywords={`${t(data.country)} ${t('SEO.keywords_common')} ${t('SEO.keywords_country')}`}
					canonical={`/country/${t(data.country)}`}
				>
					{/* Base Page - Shared component with Container */}
					<BasePage id="country-page" className="country-page pb-5" role="article">
						<article>
							<Container>
								<Col>
									<h1 className="page_text font-weight-bold text-center">{t(data.country)}</h1>
									<p className="page_subtext text-uppercase text-center">{t('authorities.title')}</p>
								</Col>
								<Row className="pt-2">
									<div className="shadowed-img">
										<img
											width="1200"
											height="400"
											className="country-img  img-fluid px-xs-5"
											src={data.photo}
											alt={'A photo that describes ' + t(data.country)}
										/>
									</div>
								</Row>
								<h2 className="font-weight-bold text-center pt-5">
									{t('countries.recomended_vaccines')}
								</h2>
								<p className="page_subtext text-uppercase text-center">
									{t('countries.travel_lenght')}
								</p>
								<Row className="pt-5">
									{data.vaccines.includes('mumps') ? <Mumps t={t} /> : <React.Fragment />}
									{data.vaccines.includes('haemophilus') ? <Haemophilus t={t} /> : <React.Fragment />}
									{data.vaccines.includes('hpv') ? <HPV t={t} /> : <React.Fragment />}
									{data.vaccines.includes('flu') ? <Flu t={t} /> : <React.Fragment />}
									{data.vaccines.includes('whooplingcough') ? (
										<WhoopplingCough t={t} />
									) : (
										<React.Fragment />
									)}
									{data.vaccines.includes('measels') ? <Measels t={t} /> : <React.Fragment />}
									{data.vaccines.includes('polio') ? <Polio t={t} /> : <React.Fragment />}
									{data.vaccines.includes('rotavirus') ? <Rotavirus t={t} /> : <React.Fragment />}
									{data.vaccines.includes('hepatitisb') ? <HepatitisB t={t} /> : <React.Fragment />}
									{data.vaccines.includes('chickenpox') ? <ChickenPox t={t} /> : <React.Fragment />}
									{data.vaccines.includes('hepatitisa') ? <HepatitisA t={t} /> : <React.Fragment />}
									{data.vaccines.includes('rubella') ? <Rubella t={t} /> : <React.Fragment />}
									{data.vaccines.includes('diphtheria') ? <Diphtheria t={t} /> : <React.Fragment />}
									{data.vaccines.includes('tbe') ? <TBE t={t} /> : <React.Fragment />}

									{data.vaccines.includes('yellowfever') ? <YellowFever t={t} /> : <React.Fragment />}
									{data.vaccines.includes('japanesebraininflammation') ? (
										<JapaneseBrainInflammation t={t} />
									) : (
										<React.Fragment />
									)}
									{data.vaccines.includes('cholera') ? <Cholera t={t} /> : <React.Fragment />}
									{data.vaccines.includes('malaria') ? <Malaria t={t} /> : <React.Fragment />}
									{data.vaccines.includes('meningococcaldiseases') ? (
										<MeningococcalDiseases t={t} />
									) : (
										<React.Fragment />
									)}
									{data.vaccines.includes('rabies') ? <Rabies t={t} /> : <React.Fragment />}
									{data.vaccines.includes('tetanus') ? <Tetanus t={t} /> : <React.Fragment />}
									{data.vaccines.includes('tuberculosis') ? (
										<Tuberculosis t={t} />
									) : (
										<React.Fragment />
									)}
									{data.vaccines.includes('typhoid') ? <Typhoid t={t} /> : <React.Fragment />}
									{data.vaccines.includes('pneumococcaldiseases') ? (
										<PneumococcalDiseases t={t} />
									) : (
										<React.Fragment />
									)}
								</Row>
								<Booking />
								<Row>
									<Col md="6">
										<h4 className="page_text font-weight-bold">{t(data.country)}</h4>
										<hr className="vaccination-page_hr" />
										<p className="float-left">
											{t(data.text1)}
											<br />
											<br />
											{t(data.text2)}
											<br />
											<br />
											<em>
												{t('countries.info_text1')}
												{t(data.country)}
												{t('countries.info_text2')}
											</em>
										</p>
										<p>
											{t('authorities.information')}
											<a
												className="country_links style_italic"
												rel="external nofollow noopener"
												target="_blank"
												href="https://rejse.ssi.dk/om-rejsevaccination"
											>
												Statens Serum Institut (SSI).&nbsp;
												<FontAwesomeIcon icon={[ 'fas', 'external-link-alt' ]} />
											</a>
										</p>
										<p className="float-left">
											{t('countries.info_text3')}
											<b>{t(data.country)}</b>
											{t('countries.info_text4')}
										</p>
									</Col>
									<Col md="6">
										<div className="google_map embed-responsive">
											<MapGL
												{...viewport}
												width="auto"
												height="550px"
												dragPan={false}
												touchAction="pan-y"
												mapStyle="mapbox://styles/mapbox/light-v9"
												mapboxApiAccessToken={MAPBOX_TOKEN}
											>
												<Marker
													latitude={lat}
													longitude={long}
													offsetLeft={-20}
													offsetTop={-10}
												>
													<Pin />
												</Marker>
											</MapGL>
										</div>
									</Col>
								</Row>
							</Container>
						</article>
						<Travels />
					</BasePage>
				</BaseLayout>
			</React.Fragment>
		);
	} else {
		return <Error error={'Please Chose a Country you want to Travel'} />;
	}
};
const Country = ({ router, t }) => {
	if (router.query.data) {
		let data = [];
		if (typeof window !== 'undefined') {
			localStorage.setItem('data_countries', router.query.data);
		}
		data = JSON.parse(router.query.data);
		return <CountryLayout t={t} data={data} />;
	} else if (typeof window !== 'undefined') {
		const data = JSON.parse(localStorage.getItem('data_countries'));
		return <CountryLayout t={t} data={data} />;
	} else {
		return <Error error={'Please Chose a Country you want to Travel'} />;
	}
};

export default translate(withRouter(Country));
